// extracted by mini-css-extract-plugin
export default {"Header":"Index_Header__YdCGc","Broker":"Index_Broker__FaO+h","Ledger":"Index_Ledger__2kG+I","Actions":"Index_Actions__JM3cK"};